import { AxiosInstance } from "axios";
export const AXIOS_INSTANCE_SET = "AXIOS_INSTANCE_SET";

export interface IAxiosInstancePayload {
  axios: AxiosInstance;
  baseURL: string;
}

export const createAxiosInstanceSetAction = (
  payload: IAxiosInstancePayload
) => {
  return { type: AXIOS_INSTANCE_SET, payload: payload };
};
